import {BBModel} from "../bb_model";
import {Collection} from "./collection";

class OrderCollection extends Collection {

    constructor(resource, set) {
        super(resource, set);
        this.promise = new Promise((resolve, reject) => {
            return resource.$get('purchases').then((orders) => {
                this.url = resource.$link('self').href;
                this.items = (Array.from(orders).map(order => new BBModel.Admin.Order(order)));
                this.items.forEach(order => set.updateItem(order));
                this.total_entries = resource.total_entries;
                if (resource.company_id) this.company_id = resource.company_id;
                resolve(this);
            }, reject);
        });
    }

    static $query(set, company, params) {
        return super.$query(OrderCollection, set, company, params);
    }

}

OrderCollection.group = 'purchases';

export {
    OrderCollection
}

